<template>
  <!-- Pagination -->
  <div class="border-t border-gray-200 dark:border-gray-700">
    <component
        :is="paginationComponent"
        v-if="shouldShowPagination"
        :next="hasNextPage"
        :previous="hasPreviousPage"
        @load-more="loadMore"
        @page="selectPage"
        :pages="totalPages"
        :page="currentPage"
        :per-page="perPage"
        :resource-count-label="resourceCountLabel"
        :current-resource-count="currentResourceCount"
        :all-matching-resource-count="allMatchingResourceCount"
    >
      <div class="my-2">
        <input
            v-model="selectPageModel"
            type="number"
               class="custom-page-selector form-control form-input form-input-bordered"
        />
        <button
            @click="() => selectPage(selectPageModel)"
                class="custom-page-selector-button flex-shrink-0 shadow rounded focus:outline-none ring-primary-200 dark:ring-gray-600 focus:ring bg-primary-500 hover:bg-primary-400 active:bg-primary-600 text-white dark:text-gray-800 inline-flex items-center font-bold px-4 h-9 text-sm flex-shrink-0 ml-4"
        >Seite wählen</button>
      </div>
      <span
          v-if="resourceCountLabel"
          class="text-xs px-4"
          :class="{
          'ml-auto': paginationComponent == 'pagination-links',
        }"
      >
        {{ resourceCountLabel }}
      </span>
    </component>
  </div>
</template>

<script>
export default {
  props: [
    'paginationComponent',
    'shouldShowPagination',
    'hasNextPage',
    'hasPreviousPage',
    'loadMore',
    'selectPage',
    'totalPages',
    'currentPage',
    'perPage',
    'resourceCountLabel',
    'currentResourceCount',
    'allMatchingResourceCount'
  ],
  data() {
    return { selectPageModel: this.currentPage }
  }
}
</script>
